module.exports = __webpack_public_path__ + "static/media/tray2.4a4c03ea.png";